export default function Skills() {
  return (
    <section id="skills" className="text-gray-600 body-font">
      <div className="container px-5 py-24 mx-auto">
        <div className="flex flex-wrap w-full mb-20">
          <div className="lg:w-2/5 w-full mb-6 lg:mb-0">
            <h1 className="sm:text-3xl text-2xl font-medium title-font mb-2 text-gray-900">
              Technical Skills
            </h1>
            <div className="h-1 w-20 bg-bluish-51 rounded"></div>
          </div>
          <p className="lg:w-3/5 w-full leading-relaxed text-gray-500">
            I have been programming since a long time now, but my journey in the <em>Framework World</em> is less. I am learning things as the time progresses.
          </p>
        </div>
        <div className="flex flex-wrap -m-4 text-center">
          <div className="p-4 md:w-1/4 sm:w-1/2 w-full">
            <div className="border-2 border-gray-200 px-4 py-6 rounded-lg">
            <img src="https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/python/python-original.svg" className="w-12 h-12 mb-3 inline-block" alt="Python" />
              <h2 className="title-font font-medium text-xl text-gray-900">Python</h2>
              <p className="leading-relaxed text-sm">Intermediate</p>
            </div>
          </div>
          <div className="p-4 md:w-1/4 sm:w-1/2 w-full">
            <div className="border-2 border-gray-200 px-4 py-6 rounded-lg">
            <img src="https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/cplusplus/cplusplus-original.svg" className="w-12 h-12 mb-3 inline-block" alt="Cpp" />
              <h2 className="title-font font-medium text-xl text-gray-900">C++</h2>
              <p className="leading-relaxed text-sm">Intermediate</p>
            </div>
          </div>
          <div className="p-4 md:w-1/4 sm:w-1/2 w-full">
            <div className="border-2 border-gray-200 px-4 py-6 rounded-lg">
            <img src="https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/css3/css3-original.svg" className="w-12 h-12 mb-3 inline-block" alt="CSS" />
              <h2 className="title-font font-medium text-xl text-gray-900">CSS</h2>
              <p className="leading-relaxed text-sm">Beginner</p>
            </div>
          </div>
          <div className="p-4 md:w-1/4 sm:w-1/2 w-full">
            <div className="border-2 border-gray-200 px-4 py-6 rounded-lg">
            <img src="https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/javascript/javascript-original.svg" className="w-12 h-12 mb-3 inline-block" alt="JavaScript" />
              <h2 className="title-font font-medium text-xl text-gray-900">JavaScript</h2>
              <p className="leading-relaxed text-sm">Beginner</p>
            </div>
          </div>
        </div>
        <div className="flex flex-wrap -m-4 text-center">
          <div className="p-4 md:w-1/4 sm:w-1/2 w-full">
            <div className="border-2 border-gray-200 px-4 py-6 rounded-lg">
                <img src="https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/django/django-plain.svg" className="w-12 h-12 mb-3 inline-block" alt="Django" />
              <h2 className="title-font font-medium text-xl text-gray-900">Django</h2>
              <p className="leading-relaxed text-sm">Intermediate</p>
            </div>
          </div>
          <div className="p-4 md:w-1/4 sm:w-1/2 w-full">
            <div className="border-2 border-gray-200 px-4 py-6 rounded-lg">
            <img src="https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/flutter/flutter-original.svg" className="w-12 h-12 mb-3 inline-block" alt="Flutter" />
              <h2 className="title-font font-medium text-xl text-gray-900">Flet</h2>
              <p className="leading-relaxed text-sm">Beginner</p>
            </div>
          </div>
          <div className="p-4 md:w-1/4 sm:w-1/2 w-full">
            <div className="border-2 border-gray-200 px-4 py-6 rounded-lg">
            <img src="https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/nextjs/nextjs-original.svg" className="w-12 h-12 mb-3 inline-block" alt="Next.js" />
              <h2 className="title-font font-medium text-xl text-gray-900">Next.js</h2>
              <p className="leading-relaxed text-sm">Beginner</p>
            </div>
          </div>
          <div className="p-4 md:w-1/4 sm:w-1/2 w-full">
            <div className="border-2 border-gray-200 px-4 py-6 rounded-lg">
            <img src="https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/react/react-original.svg" className="w-12 h-12 mb-3 inline-block" alt="Next.js" />
              <h2 className="title-font font-medium text-xl text-gray-900">React</h2>
              <p className="leading-relaxed text-sm">Beginner</p>
            </div>
          </div>
        </div>
      </div>
      <div>
        <i className="devicon-threedsmax-plain colored"></i>
      </div>
    </section>
  );
}
